import React from 'react';
import { Text } from '@chakra-ui/react';
import CustomLink from "../components/Link/CustomLink";

const renderTextWithLinksAndBold = (text: string): React.ReactNode[] => {
    const linksAndBoldRegex = /(\[([^\]]+)\]\(([^)]+)\)|\*(.*?)\*)/g;
    let lastIndex = 0;
    const elements: React.ReactNode[] = [];

    let matches;
    while ((matches = linksAndBoldRegex.exec(text)) !== null) {
        const [fullMatch, , linkText, linkHref, boldText] = matches;
        const beforeText = text.substring(lastIndex, matches.index);
        elements.push(
            <React.Fragment key={`${beforeText}_${linkHref || boldText}`}>
                {beforeText && (
                    <Text as="span">{beforeText}</Text>
                )}
                {linkText && (
                    <CustomLink _hover={{ textDecoration: 'underline' }}
                                color="teal.500"
                                href={linkHref}
                                width="100%">
                        {linkText}
                    </CustomLink>
                )}
                {boldText && (
                    <Text key={boldText} as="span" fontWeight="bold">{boldText}</Text>
                )}
            </React.Fragment>
        );
        lastIndex = linksAndBoldRegex.lastIndex;
    }
    const remainingText = text.substring(lastIndex);
    if (remainingText) {
        elements.push(
            <Text key={remainingText} as="span">{remainingText}</Text>
        );
    }

    return elements;
};

export default renderTextWithLinksAndBold;